import { z } from 'zod';

// Search result types
export const searchFileResultSchema = z.object({
  id: z.string(),
  name: z.string(),
  originalName: z.string(),
  mimeType: z.string(),
  size: z.number(),
  folderId: z.string().nullable(),
  createdAt: z.string(),
});

export type SearchFileResult = z.infer<typeof searchFileResultSchema>;

export const searchFolderResultSchema = z.object({
  id: z.string(),
  name: z.string(),
  path: z.string(),
  clientId: z.string().nullable(),
  createdAt: z.string(),
});

export type SearchFolderResult = z.infer<typeof searchFolderResultSchema>;

export const searchClientResultSchema = z.object({
  id: z.string(),
  name: z.string(),
  company: z.string().nullable(),
  email: z.string().nullable(),
  createdAt: z.string(),
});

export type SearchClientResult = z.infer<typeof searchClientResultSchema>;

// Search response
export const searchResponseSchema = z.object({
  query: z.string(),
  totalResults: z.number(),
  results: z.object({
    files: z.array(searchFileResultSchema),
    folders: z.array(searchFolderResultSchema),
    clients: z.array(searchClientResultSchema),
  }),
});

export type SearchResponse = z.infer<typeof searchResponseSchema>;

// Suggestions response
export const searchSuggestionSchema = z.object({
  name: z.string(),
  type: z.enum(['file', 'client']),
});

export type SearchSuggestion = z.infer<typeof searchSuggestionSchema>;

export const searchSuggestionsResponseSchema = z.object({
  suggestions: z.array(searchSuggestionSchema),
});

export type SearchSuggestionsResponse = z.infer<typeof searchSuggestionsResponseSchema>;
